export default "__VITE_ASSET__ZHrwQxJf__"